import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { NavLink, useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Icon, LanguagesButton } from '../../../elements'
import { logout } from '../../../store/authSlice'
import { ThemeToggler } from '../../ThemeToggler'

import './Header.scss'

export const Header = ({ user }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const htmlElement = document.documentElement

    const [darkTheme, setDarkTheme] = useState(htmlElement.classList.contains('dark-mode'))

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setDarkTheme(htmlElement.classList.contains('dark-mode'))
        })
        observer.observe(htmlElement, { attributes: true, attributeFilter: ['class'] })
        return () => observer.disconnect()
    }, [])


    const handleLogout = async () => {
        dispatch(logout())
        navigate("/auth")
    }

    return (
        <header className='Header'>
            <div className="container">
                <div className="left-part">
                    <div className="logo-container">
                        <img src={`/favicon-${darkTheme ? "dark" : "light"}.png`} className="logo-icon" />
                        <h1 className="title">{t("auth.title")}</h1></div>
                    <nav className="nav">
                        <NavLink to="/" end className="nav-link">
                            {t("nav.home")}
                        </NavLink>
                        <NavLink to="/sites" className="nav-link">
                            {t("nav.sites")}
                        </NavLink>
                        {user?.role === "admin" && (
                            <NavLink to="/users" className="nav-link">
                                {t("nav.users")}
                            </NavLink>
                        )}
                    </nav>
                </div>
                <div className="right-part">
                    <LanguagesButton direction="left" />
                    <ThemeToggler />
                    <i className='separator' />
                    <div className="user-info">
                        <div className="user-details">
                            <span className="user-name">{user?.login}</span>
                            <span className="user-role">{user?.role}</span>
                        </div>
                    </div>
                    <button onClick={handleLogout} className="logout-btn">
                        <Icon src="/assets/icons/logout.svg" className="nav-icon" />
                    </button>

                </div>
            </div>
        </header>
    )
}